import { createFileRoute } from "@tanstack/react-router";
import { graphql } from "@repo/graphql-types";
import Left from "@repo/icons/default/Left";
import { AsyncDataWrapper } from "@/components/ui/async-data-wrapper";
import {
  HeaderRoot,
  HeaderTitle,
  HeaderUpButton,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { UnsubscribeAssistProComponent } from "@/components/assist/unsubscribe-assist-pro";
import { ServicePackageEnum } from "@/lib/enums/service-package-enum";
import { useGraphQL } from "@/hooks/use-graphql";
import { validatePackageAccess } from "@/lib/assist-package-guard";

import type { JSX } from "react";

const UnsubscribeAssistProPageQuery = graphql(/* GraphQL */ `
  query UnsubscribeAssistProPageQuery {
    ...UnsubscribeAssistProFragment
  }
`);

const UnsubscribeAssistProPage = (): JSX.Element => {
  const queryResult = useGraphQL(UnsubscribeAssistProPageQuery, {});
  const { data } = queryResult;
  return (
    <>
      <HeaderRoot>
        <HeaderUpButton icon={Left} align="start" />
        <HeaderTitle title="Cancelamento" align="center" />
      </HeaderRoot>
      <Page className="px-0 pb-0 flex flex-col">
        <AsyncDataWrapper {...queryResult}>
          {data ? <UnsubscribeAssistProComponent data={data} /> : null}
        </AsyncDataWrapper>
      </Page>
    </>
  );
};

export const Route = createFileRoute("/settings/assist/unsubscribe-assist-pro/")({
  component: UnsubscribeAssistProPage,
  beforeLoad: ({ context }) => {
    const user = context.user;
    validatePackageAccess({
      user,
      packageService: ServicePackageEnum.Pro,
    });
  },
});
